import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import DatePicker from "react-datepicker";
import { Modal } from "react-bootstrap";
import { MyContext, ListContext } from "./MyContext";
import { HelpText } from "./styleCustom";
// import AuthHelperMethods from "./AuthHelperMethods";
import Payment from "./payment";
import CheckoutSavedPaymentForm from "./paymentSavedForm";
import {
  stringToDateObj,
  dateISOtoStringMed,
  dateISOtoStringShort,
  dateObjToDBDate,
} from "./momentUtils";
import { DATEPICKER_DATE_DISPLAY } from "./UserSettings";
import PrivateRoute from "./privateRoute";
import COLORS, { nametagStyle } from "./styleConstants";
import { MemberLinks } from "./clientHomePage";
import "react-datepicker/dist/react-datepicker.css";
import { ButtonOrange, ButtonBlue, ModalHeaderBlue } from "./formComponents";
import { Trash, EditIconPlain } from "./icons";
import { useAlert } from "react-alert";

import ManualPurchase from "./manualPurchaseForm";
import PackageList from "./packageList";
import PackageDetailsEdit from "./packageDetailsEdit";
import { createReceiptDetails } from "./paymentReceiptDetails";
import {
  buildPaymentDetails,
  buildInvoiceUpdateDetails,
} from "./paymentDetails";
import { FeatureAccess } from "./featureAccess";

import Auth from "./Auth";

const OnlinePurchase = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  const [isPhoneViewport, setIsPhoneViewport] = useState(
    window.innerWidth <= 600,
  );
  let history = useHistory();
  const location = useLocation();
  const editingInvoice = location.state?.editingInvoice;
  const alert = useAlert();
  const [warning, setWarning] = useState("");
  const [savingInvoice, setSavingInvoice] = useState(false);
  const [invoiceSaveError, setInvoiceSaveError] = useState("");
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(() => ({
    purchase_date: editingInvoice
      ? moment(
          editingInvoice.invoice_date ||
            editingInvoice.received ||
            editingInvoice.purchase_date,
        ).format("YYYY-MM-DD")
      : "",
    reference: editingInvoice?.reference ?? "",
    notes: editingInvoice?.notes ?? "",
  }));
  const savingInvoiceRef = useRef(false);

  const openInvoiceDetails = () => {
    setInvoiceSaveError("");
    try {
      buildInvoiceUpdateDetails(listState, editingInvoice, invoiceDetails);
      setShowInvoiceDetails(true);
    } catch (error) {
      setInvoiceSaveError(error.message);
    }
  };

  const saveInvoiceChanges = async () => {
    if (savingInvoiceRef.current || !editingInvoice) return;
    setInvoiceSaveError("");
    try {
      if (Auth.getUserType() !== "ADM" || editingInvoice.paid != false) {
        throw new Error("Only unpaid invoices can be edited by an admin.");
      }
      if (!moment(invoiceDetails.purchase_date, "YYYY-MM-DD", true).isValid()) {
        throw new Error("Enter a valid invoice purchase date.");
      }
      const params = buildInvoiceUpdateDetails(
        listState,
        editingInvoice,
        invoiceDetails,
      );
      savingInvoiceRef.current = true;
      setSavingInvoice(true);
      const result = await Auth.api("payments/updateInvoice", "post", params);
      if (
        !result ||
        !(result.status >= 200 && result.status < 300) ||
        result.data?.success === false ||
        result.data?.error
      ) {
        throw new Error(
          result?.data?.message ||
            result?.data?.error ||
            "Invoice update was not confirmed.",
        );
      }
      alert.show("Invoice updated successfully.", { type: "success" });
      dispatch2(["CLEAR_CART"]);
      history.push(location.state.invoiceReturnUrl);
    } catch (error) {
      setInvoiceSaveError(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Unable to update this invoice.",
      );
    } finally {
      savingInvoiceRef.current = false;
      setSavingInvoice(false);
    }
  };

  const [productList, setProductList] = useState([]);

  const [currentProduct, setCurrentProduct] = useState({});
  const [validFrom, setValidFrom] = useState(moment().toDate());
  const [purchaseDate, setPurchaseDate] = useState(moment().toDate());
  const [expiry, setExpiry] = useState(moment().toDate());
  const [cartProducts, setCartProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [counter, SetCounter] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showManual, setShowManual] = useState(false);
  const [price, setPrice] = useState();
  const [count, setCount] = useState();
  const [itemNote, setItemNote] = useState();
  const [wait, setWait] = useState(false);
  const chargeFee =
    mystate.farmDefaults.stripe_convenience_fee > 0 ? true : false;
  const feeAmount = mystate.farmDefaults.stripe_convenience_fee;
  const [credits, setCredits] = useState([]);
  const [subscriptionMode, setSubscriptionMode] = useState(false);
  const [billingStartOption, setBillingStartOption] = useState("next_month");
  const [packageCoverageOption, setPackageCoverageOption] =
    useState("charge_month");
  const [customBillingDate, setCustomBillingDate] = useState(moment().toDate());

  useEffect(() => {
    const updatePhoneViewport = () =>
      setIsPhoneViewport(window.innerWidth <= 600);
    window.addEventListener("resize", updatePhoneViewport);
    return () => window.removeEventListener("resize", updatePhoneViewport);
  }, []);

  const getNextBillingDate = () => {
    if (billingStartOption === "today") return dateObjToDBDate(new Date());
    if (billingStartOption === "custom")
      return dateObjToDBDate(customBillingDate);
    return moment().add(1, "month").startOf("month").format("YYYY-MM-DD");
  };

  const getPackagePeriodStart = () => {
    const packageStart = moment(getNextBillingDate()).startOf("month");
    if (packageCoverageOption === "following_month")
      packageStart.add(1, "month");
    return packageStart.format("YYYY-MM-DD");
  };

  const firstChargeDateExample = moment(getNextBillingDate());
  const chargeMonthCoverageExample = firstChargeDateExample
    .clone()
    .startOf("month")
    .format("MMM D, YYYY");
  const followingMonthCoverageExample = firstChargeDateExample
    .clone()
    .startOf("month")
    .add(1, "month")
    .format("MMM D, YYYY");

  useEffect(() => {
    if (!location.state?.startSubscription) return;

    dispatch2(["CLEAR_CART"]);
    setSubscriptionMode(true);
    history.replace(location.pathname, {});
  }, [dispatch2, history, location.pathname, location.state]);

  //useFetch("products/index", "PRODUCTS_GET", "dispatchlist", params);

  useEffect(
    () => {
      return () => {
        dispatch2(["CLEAR_CART"]);
        dispatch2(["SET_CURRENT_PRODUCT", {}]);
        dispatch2(["SET_PAYMENT_INTENT", {}]);
        dispatch2(["SET_PAYMENT_METHODS", []]);
      };
    },
    //eslint-disable-next-line
    [],
    [],
  );
  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      // params.student = listState.currentClient.student_id;
      params.students = listState.members.map((member) => member.student_id);
      console.log(params);
      const result = await Auth.api(`items/credits`, "get", params);
      setCredits(result.data.credits);
    };
    fetchData();
  }, []);

  const onCloseModal = () => {
    console.log("ON CLOES MODAL");
    setShowModal(false);
    dispatch2(["EDIT_CART", listState.currentProduct]); //* update cart with product changes *//
  };

  const stripeFeeTotal = () => {
    var stripeTotal = parseFloat(total * 1.029 + 0.3);

    stripeTotal = Number(stripeTotal).toFixed(2);
    return stripeTotal;
  };

  const handleClickEditProduct = (productIn) => {
    console.log(productIn);
    console.log(stringToDateObj(productIn.purchase_date));
    dispatch2(["SET_CURRENT_PRODUCT", productIn]);
    setShowModal(true);
  };

  const removeProduct = (productin) => {
    console.log(productin);
    let stripe_convenience_fee = mystate.farmDefaults.stripe_convenience_fee;
    dispatch2(["REMOVE_FROM_CART", productin, stripe_convenience_fee]);
  };

  const checkout = () => {
    //** also has link  *//
    if (listState.cartTotal < parseFloat(0.01)) alert("cart total is empty");
  };

  const cancelCheckout = () => {
    dispatch2(["CLEAR_CART"]);
  };

  if (!listState.products) return null;
  return (
    <>
      <div style={{ display: "flex", flex: "1 1 100%", flexWrap: "wrap" }}>
        <MemberLinks
          verb={""}
          page={
            editingInvoice
              ? `Edit Invoice #${editingInvoice.invoice_number || editingInvoice.id}`
              : "Purchase Package"
          }
          link={"online"}
        />
        <HelpText>
          {
            "To purchase a package for another account member on the same transaction, click their name where listed under Account Members."
          }
        </HelpText>
        <div style={{ fontSize: 16 }}>
          {"Click on package below to add to cart"}
        </div>
      </div>
      <div
        className="wrapper"
        style={{
          display: "flex",
          flexWrap: "wrap",
          flex: subscriptionMode ? "1 1 100%" : "1 1 70%",
          alignItems: "flex-start",
          gap: subscriptionMode ? 12 : undefined,
        }}
      >
        {(editingInvoice || subscriptionMode) && (
          <details
            open
            style={{
              flex: "1 1 100%",
              minWidth: 0,
              margin: "0 0 12px",
              padding: "8px 10px",
              border: "1px solid #c3e3e9",
              borderRadius: 4,
              background: "#f5fafb",
              color: COLORS.textDark,
              fontSize: 13,
            }}
          >
            <summary
              style={{
                color: COLORS.blue,
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {editingInvoice
                ? "Invoice editing tips"
                : "Subscription package tips"}
            </summary>
            <p style={{ margin: "8px 0 0" }}>
              {editingInvoice
                ? "Adjust existing items or add and remove packages. Continue with Invoice Changes to review the invoice date, reference, and notes before saving. An invoice must retain at least one item."
                : "Choose the first charge date and add one or more packages for this subscription. You can add multiple packages and multiple students on one subscription."}
            </p>
          </details>
        )}
        {1 == 2 && (
          <div>
            {credits.map((credit) => (
              <div key={credit.id}>{credit.price}</div>
            ))}
          </div>
        )}
        <div
          className="cart"
          style={{
            display: "flex",
            width: isPhoneViewport ? 300 : 400,
            maxWidth: "100%",
            boxSizing: "border-box",
            flexWrap: "wrap",
            borderx: "solid",
            marginLeft: 30,
            xminWidth: 250,
            orderx: 1,
            ...((editingInvoice || subscriptionMode) && {
              padding: 12,
              border: `1px solid ${COLORS.lightblue}`,
              borderLeft: `4px solid ${COLORS.blue}`,
              borderRadius: 4,
              gap: 8,
            }),
          }}
        >
          {(editingInvoice || subscriptionMode) && (
            <div
              style={{
                flex: "1 1 100%",
                color: COLORS.blue,
                fontSize: 15,
                fontWeight: "bold",
                marginBottom: 8,
              }}
            >
              {editingInvoice
                ? `Editing Invoice #${editingInvoice.invoice_number || editingInvoice.id}`
                : "Subscription Cart"}
            </div>
          )}
          {subscriptionMode && (
            <div
              style={{
                display: "flex",
                flex: "1 1 100%",
                flexDirection: "column",
                gap: 6,
                marginBottom: 10,
              }}
            >
              <label
                htmlFor="subscription-first-charge"
                style={{
                  color: COLORS.textDark,
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                1. First charge date
              </label>
              <select
                id="subscription-first-charge"
                value={billingStartOption}
                onChange={(event) => setBillingStartOption(event.target.value)}
                style={{ width: "100%", padding: 8 }}
              >
                <option value="next_month">First of next month</option>
                <option value="today">Today</option>
                <option value="custom">Choose a date</option>
              </select>
              {billingStartOption === "custom" && (
                <DatePicker
                  selected={customBillingDate}
                  onChange={(date) => date && setCustomBillingDate(date)}
                  minDate={moment().startOf("month").toDate()}
                  dateFormat={DATEPICKER_DATE_DISPLAY}
                />
              )}
              <fieldset
                style={{
                  border: 0,
                  borderTop: "1px solid #c3e3e9",
                  padding: "10px 0 0",
                  margin: "10px 0 0",
                }}
              >
                <legend
                  style={{
                    color: COLORS.textDark,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  2. Package coverage starts
                </legend>
                <label
                  style={{
                    display: "block",
                    marginBottom: 6,
                    fontWeight: "normal",
                    fontSize: 12,
                  }}
                >
                  <input
                    type="radio"
                    name="subscription-package-coverage"
                    value="charge_month"
                    checked={packageCoverageOption === "charge_month"}
                    onChange={() => setPackageCoverageOption("charge_month")}
                  />{" "}
                  First of the charge date month
                </label>
                <div
                  style={{
                    margin: "-2px 0 10px 22px",
                    color: COLORS.textgrey,
                    fontSize: 11,
                  }}
                >
                  Example: a first charge on{" "}
                  {firstChargeDateExample.format("MMM D, YYYY")} starts package
                  coverage on {chargeMonthCoverageExample} and for that entire
                  month.
                </div>

                <label
                  style={{
                    display: "block",
                    fontWeight: "normal",
                    fontSize: 12,
                  }}
                >
                  <input
                    type="radio"
                    name="subscription-package-coverage"
                    value="following_month"
                    checked={packageCoverageOption === "following_month"}
                    onChange={() => setPackageCoverageOption("following_month")}
                  />{" "}
                  First of the following charge date month
                </label>
                <div
                  style={{
                    margin: "-2px 0 0 22px",
                    color: COLORS.textgrey,
                    fontSize: 11,
                  }}
                >
                  Example: if the first charge is on the 25th, package coverage
                  starts on the 1st of the following month and covers that
                  entire month.
                </div>
              </fieldset>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  borderTop: "1px solid #c3e3e9",
                  paddingTop: 10,
                  marginTop: 8,
                }}
              >
                <span
                  style={{
                    color: COLORS.textDark,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  3. Add packages
                </span>
                <span style={{ color: COLORS.textgrey, fontSize: 12 }}>
                  Click on packages to add them to this subscription.
                </span>
              </div>
            </div>
          )}
          <CartList
            handleClickEditProduct={handleClickEditProduct}
            removeProduct={removeProduct}
            readOnly={subscriptionMode}
          />
          <CartTotal subscriptionMode={subscriptionMode} />
          {subscriptionMode && (
            <div
              style={{
                flex: "1 1 100%",
                marginBottom: 12,
                color: COLORS.textgrey,
                fontSize: 12,
                lineHeight: 1.45,
              }}
            >
              The total shown excludes any applicable taxes or convenience fees.
              Your saved card will not be charged now; it will be charged on the
              first charge date. A saved card must be on file. Manage saved
              cards on the{" "}
              <Link
                to={`/admin/clienthome/${listState.currentClient.id}/account`}
              >
                Account page
              </Link>
              .
            </div>
          )}

          {editingInvoice ? (
            <>
              {invoiceSaveError && (
                <div role="alert" style={{ color: "#b42318", width: "100%" }}>
                  {invoiceSaveError}
                </div>
              )}
              <ButtonOrange
                label={
                  savingInvoice ? "Saving..." : "Continue with Invoice Changes"
                }
                disabled={savingInvoice}
                onClick={openInvoiceDetails}
              />
              <ButtonBlue
                label="Cancel Invoice Edit"
                onClick={() => {
                  if (savingInvoiceRef.current) return;
                  dispatch2(["CLEAR_CART"]);
                  history.push(location.state.invoiceReturnUrl);
                }}
              />
            </>
          ) : (
            <PayButtons
              {...props}
              subscriptionMode={subscriptionMode}
              onSubscriptionComplete={() => setSubscriptionMode(false)}
              nextBillingDate={getNextBillingDate()}
              packagePeriodStart={getPackagePeriodStart()}
            />
          )}
        </div>
        <PackageList />
        <PackageDetailsEdit
          onCloseModal={onCloseModal}
          showModal={showModal && !subscriptionMode}
          setShowModal={setShowModal}
        />
      </div>
      {editingInvoice && (
        <Modal
          show={showInvoiceDetails}
          onHide={() =>
            !savingInvoiceRef.current && setShowInvoiceDetails(false)
          }
          backdrop="static"
        >
          <ModalHeaderBlue>
            <Modal.Title>Edit Invoice Details</Modal.Title>
          </ModalHeaderBlue>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              saveInvoiceChanges();
            }}
          >
            <Modal.Body>
              <fieldset
                disabled={savingInvoice}
                style={{ border: 0, padding: 0, minWidth: 0 }}
              >
                <label style={{ display: "block", marginBottom: 16 }}>
                  Purchase Date
                  <div>
                    <DatePicker
                      dateFormat={DATEPICKER_DATE_DISPLAY}
                      selected={
                        invoiceDetails.purchase_date
                          ? stringToDateObj(invoiceDetails.purchase_date)
                          : null
                      }
                      onChange={(date) =>
                        setInvoiceDetails((current) => ({
                          ...current,
                          purchase_date: date ? dateObjToDBDate(date) : "",
                        }))
                      }
                    />
                  </div>
                </label>
                <label style={{ display: "block", marginBottom: 16 }}>
                  Reference
                  <input
                    value={invoiceDetails.reference}
                    onChange={(event) =>
                      setInvoiceDetails({
                        ...invoiceDetails,
                        reference: event.target.value,
                      })
                    }
                    style={{ display: "block", width: "100%" }}
                  />
                </label>
                <label style={{ display: "block" }}>
                  Notes
                  <textarea
                    rows={5}
                    value={invoiceDetails.notes}
                    onChange={(event) =>
                      setInvoiceDetails({
                        ...invoiceDetails,
                        notes: event.target.value,
                      })
                    }
                    style={{ display: "block", width: "100%" }}
                  />
                </label>
              </fieldset>
              {invoiceSaveError && (
                <div role="alert" style={{ color: "#b42318" }}>
                  {invoiceSaveError}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <ButtonBlue
                label="Back to Items"
                onClick={(event) => {
                  event.preventDefault();
                  if (!savingInvoiceRef.current) setShowInvoiceDetails(false);
                }}
              />
              <ButtonOrange
                type="submit"
                label={savingInvoice ? "Saving..." : "Save Invoice Changes"}
                disabled={savingInvoice}
              />
            </Modal.Footer>
          </form>
        </Modal>
      )}
      <PrivateRoute
        exact
        path={`${props.match.url}/manual`}
        component={ManualPurchase}
      />
      <PrivateRoute
        exact
        path={`${props.match.url}/manualInvoice`}
        component={ManualPurchase}
        thisisinvoice={"thisisinvoice"}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flex: "1 1 100%",
          minHeight: 500,
        }}
      >
        <PrivateRoute
          exact
          path={`${props.match.url}/payments`}
          component={Payment}
        />
        <PrivateRoute
          exact
          path={`${props.match.url}/paymentsSaved`}
          component={CheckoutSavedPaymentForm}
        />
      </div>
    </>
  );
};

export const CartList = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  console.log(listState.cartProducts);
  return (
    <div style={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}>
      {" "}
      <div>
        {listState.cartProducts.length > 0 && (
          <div
            style={{
              fontSize: 20,
              marginBottom: props.readOnly ? 12 : 40,
            }}
          >
            Checkout Cart
          </div>
        )}
      </div>
      {!props.readOnly &&
        Auth.getUserType() == "ADM" &&
        listState.cartProducts.length > 0 && (
          <HelpText>
            {
              "Admins may click on the blue edit icon to change the package details"
            }
          </HelpText>
        )}
      {listState.cartProducts.length > 0 &&
        listState.cartProducts.map((product, idx) => (
          <div
            className="eachPurchase"
            key={idx}
            style={{
              ...nametagStyle,
              ...(props.readOnly ? { padding: "2px 5px" } : {}),
              display: "flex",
              flex: "1 1 100%",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div
              className="topLine"
              style={{
                display: "flex",
                flexWrap: "nowrap",
                justifyContent: "space-between",
                flex: "1 1 100%",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  flex: "1 1 100%",
                }}
              >
                {product.product_name}
              </div>

              <div
                className="editTrashIcons"
                style={{ display: "flex", flexDirection: "row" }}
              >
                {!props.readOnly && Auth.getUserType() == "ADM" && (
                  <div
                    className="editProduct"
                    onClick={() =>
                      props.handleClickEditProduct(product) || null
                    }
                    style={{ margin: 5 }}
                  >
                    <EditIconPlain color={COLORS.blue} />
                  </div>
                )}
                <div
                  className="removeProduct"
                  onClick={() => props.removeProduct(product)}
                  style={{ margin: 5 }}
                >
                  <Trash />
                </div>
              </div>
            </div>
            <div
              style={{ display: "flex", flex: "1 1 100%" }}
            >{`${product.student_name} `}</div>
            <div style={{ display: "flex", flex: "1 1 100%" }}>
              {product.registration_title || ""}
            </div>
            <div
              className="productDetails"
              style={{
                display: "flex",
                flex: "1 1 100%",
                justifyContent: "space-between",
                color: COLORS.textgrey,
              }}
            >
              {!props.readOnly && (
                <>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>purchased</div>
                    <div>{dateISOtoStringShort(product.purchase_date)}</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>starts</div>
                    <div>
                      {dateISOtoStringShort(product.package_start_date)}
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>expires</div>
                    <div>
                      {dateISOtoStringShort(product.package_expiry_date)}
                    </div>
                  </div>
                </>
              )}

              <div style={{ display: "flex", flexDirection: "column" }}>
                {" "}
                <div>{`count`}</div>
                <div> {product.start_count}</div>
              </div>
            </div>
            {1 == 2 && product.is_auto && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWeight: "bold",
                  paddingTop: 3,
                }}
              >
                {`This package renews on  ${dateISOtoStringMed(
                  product.package_renew_date,
                )} `}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flex: "1 1 100%",
                fontSize: 16,
                fontWeight: "bold",
              }}
            >
              {" "}
              {`${mystate.farmDefaults.currency_symbol}${Number(
                product.product_price,
              ).toFixed(2)}`}
            </div>
          </div>
        ))}
    </div>
  );
};

export const CartTotal = ({ subscriptionMode = false }) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  if (listState.cartProducts.length < 1) return null;

  return (
    <div
      className="ListSummary"
      style={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 100%",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      {!mystate.farmDefaults.stripe_convenience_fee > 0 && (
        <div
          className="total"
          style={{
            display: "flex",
            flex: "1 1 100%",
            marginTop: 5,
            padding: 2,
            justifyContent: "space-between",
          }}
        >
          {listState.cartProducts.length > 0 && (
            <>
              {" "}
              <div>{"Subtotal"}</div>
              <div style={{ textAlign: "right" }}>{listState.cartSubtotal}</div>
            </>
          )}
        </div>
      )}
      <div
        className="salestax"
        style={{
          display: "flex",
          flex: "1 1 100%",

          padding: 2,
          justifyContent: "space-between",
        }}
      >
        {listState.cartProducts.length > 0 &&
          mystate.farmDefaults.tax_percent > 0 && (
            <>
              {" "}
              <div>{`Sales Tax ${parseFloat(
                mystate.farmDefaults.tax_percent * 100,
              )}%`}</div>
              <div style={{ textAlign: "right" }}>{listState.cartTax}</div>
            </>
          )}
      </div>
      <div
        className="stripefee"
        style={{
          display: "flex",
          flex: "1 1 100%",

          padding: 2,
          justifyContent: "space-between",
        }}
      >
        {listState.cartProducts.length > 0 &&
          mystate.farmDefaults.stripe_convenience_fee > 0 && (
            <>
              {" "}
              <div>{`Convenience Fee if paying by card : ${parseFloat(
                mystate.farmDefaults.stripe_convenience_fee * 100,
              )}%`}</div>
              <div style={{ textAlign: "right" }}>{listState.cartFee}</div>
            </>
          )}
      </div>
      <div
        className="stripefeeplustotal"
        style={{
          ...nametagStyle,
          display: "flex",
          flex: "1 1 100%",
          marginBottom: subscriptionMode ? 8 : 50,
          justifyContent: "space-between",
          fontSize: 16,
          fontWeight: "bold",
          marginTop: 20,
        }}
      >
        {listState.cartProducts.length > 0 && (
          <>
            {" "}
            <div style={{ fontSize: 16, fontWeight: "bold" }}>{"Total"}</div>
            <div
              style={{ textAlign: "right", fontSize: 16, fontWeight: "bold" }}
            >{`${mystate.farmDefaults.currency_symbol}${listState.cartTotal}`}</div>
          </>
        )}
      </div>
    </div>
  );
};

export const PayButtons = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  let history = useHistory();
  const alert = useAlert(); // Add this line to use react-alert in PayButtons
  const subscriptionIdempotencyKeyRef = useRef(null);
  const savingSubscriptionRef = useRef(false);
  const [savingSubscription, setSavingSubscription] = useState(false);

  const checkout = () => {
    //** also has link  *//
    if (listState.cartTotal < parseFloat(0.01)) alert("cart total is empty");
  };

  const cancelCheckout = () => {
    if (savingSubscriptionRef.current) return;
    dispatch2(["CLEAR_CART"]);
    if (props.subscriptionMode) props.onSubscriptionComplete?.();
  };

  const offlinePayment = async () => {
    try {
      dispatch2(["ADD_CART_FEE", mystate.farmDefaults.stripe_convenience_fee]);

      let params = {
        total: parseInt(listState.cartTotal * 100),
        account_holder: listState.accountHolder.people_bill_person_name,
        student: listState.currentClient.person_name,
        account_id: listState.accountHolder.id,
        customer_id: listState.accountHolder.stripe_customer_id,
      };
      console.log("*************createPaymentIntent*************");
      console.log(params);
      const result = await Auth.api(
        "payments/createPaymentIntentNoCard/",
        "post",
        params,
      );
      console.log(result);
      console.log(result.data.payment_intent.client_secret);
    } catch (error) {
      console.log(error.message);
      //  alert.show(error.message, { timeout: 3000, type: "error" });
    }
  };

  const createSubscription = async () => {
    if (savingSubscriptionRef.current) return;
    if (listState.cartProducts.length === 0) {
      alert.show("Choose at least one package for the subscription.", {
        type: "error",
      });
      return;
    }
    savingSubscriptionRef.current = true;
    setSavingSubscription(true);

    try {
      console.log("Creating subscription...");

      if (!subscriptionIdempotencyKeyRef.current) {
        subscriptionIdempotencyKeyRef.current = uuidv4();
      }

      let params = {
        studentName: listState.currentClient.person_name,
        studentId: listState.currentClient.student_id,
        accountId: listState.accountHolder.id,
        billing_person_id: listState.currentClient.billing_person_id,
        customerId: listState.accountHolder.stripe_customer_id,
        // priceId: listState.currentProduct.stripe_price_id,
        //stripeProductId: listState.currentProduct.stripe_product_id,
        productId: listState.currentProduct.id,
        startDate: listState.currentProduct.package_start_date,
        receipt_details: createReceiptDetails(listState.cartProducts),
        idempotency_key: subscriptionIdempotencyKeyRef.current,
        billing_interval: "month",
        billing_interval_count: 1,
        next_billing_date: props.nextBillingDate,
        package_period_start: props.packagePeriodStart,
      };

      //! changing to not use stripe for subscriptions
      /* 
     const result = await Auth.api(
        "subscriptions/createClientSubscriptionInStripe/",
        "post",
        params,
      );
      */

      const result = await Auth.api(
        "subscriptions/createClientSubscriptionInDB/",
        "post",
        params,
      );

      // Check for error in the result

      dispatch({
        type: "FETCH_SUCCESS",
      });
      // Show success message
      alert.show("Subscription created successfully!", {
        timeout: 5000,
        type: "success",
      });
      dispatch2(["CLEAR_CART"]);
      dispatch2(["SET_CURRENT_PRODUCT", {}]);
      dispatch2(["SET_PAYMENT_INTENT", {}]);
      dispatch2(["SET_PAYMENT_METHODS", []]);
      props.onSubscriptionComplete?.();

      console.log("Subscription created:", result);
      history.push(`/admin/clienthome/${listState.currentClient.id}/payments`);

      return result;
    } catch (error) {
      dispatch({
        type: "FETCH_ERROR",
      });
      const backendMsg =
        error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : error.message;
      // console.log("Error creating subscription:", backendMsg);
      // alert.show("Error creating subscription:", backendMsg);

      // Show error message but stay in current modal

      alert.show(
        `Failed to create subscription: ${
          backendMsg || "Please check your information and try again."
        }`,
        { timeout: 18000, type: "error" },
      );
    } finally {
      savingSubscriptionRef.current = false;
      setSavingSubscription(false);
    }
  };

  const checkForSavedPayment = async () => {
    //! check for student_id - issues where there is no student_id and card payment goes through but then package is not created

    if (listState.cartProducts.filter((x) => !x.student_id).length > 0) {
      alert("There was an error with your cart. Please start again");
      cancelCheckout();
      return;
    }
    if (listState.cartTotal < parseFloat(0.01)) {
      alert("cart total is empty");

      return;
    }

    try {
      dispatch({
        type: "FETCH_INIT",
      });
      let params = {
        total: parseInt(listState.cartTotal * 100),
        account_holder: listState.accountHolder.people_bill_person_name,
        student: listState.currentClient.person_name,
        account_id: listState.accountHolder.id,
        person_id: listState.accountHolder.id,
        ...buildPaymentDetails(listState),
        student_id: listState.quickpaystudentid || null,
        is_quickpay: Boolean(listState.quickpaystudentid),
        transaction_type: "online",
        online_purchase: 0,
        payment_type: "purchase", //! hardcoded here as not coming from invoice page thus is a regular payment
        idempotency_key: uuidv4(),
      };
      const cardsResult = await Auth.api(
        "payments/getCustomerPaymentMethods",
        "get",
        { person_id: listState.accountHolder.id },
        { skipGlobalErrorHandler: true },
      );
      const methods = cardsResult.data?.payment_methods;
      if (!Array.isArray(methods)) {
        throw new Error("Unable to retrieve saved payment methods.");
      }
      dispatch2(["SET_PAYMENT_INTENT", {}]);
      dispatch2(["SET_PAYMENT_METHODS", methods]);
      dispatch({ type: "FETCH_SUCCESS" });
      history.push(
        `${props.match.url}/${methods.length > 0 ? "paymentsSaved" : "payments"}`,
        {
          pendingPaymentParams: params,
        },
      );
    } catch (e) {
      console.log(e.message);
      // console.log("[error]", result.error);
      dispatch({
        type: "FETCH_ERROR",
      });
      /* alert(
        "Sorry - there has been an error with your transaction and it has not been processed.",
      );
      */
    }
  };

  if (listState.cartProducts.length < 1 && !props.subscriptionMode) return null;
  return (
    <div
      className="payAndCancelButtons"
      style={{
        display: "flex",
        justifyContent: "center",
        flex: "1 1 100%",
        flexDirection: "column",
      }}
    >
      <div
        className="payButtonContainer"
        style={{
          display: "flex",
          justifyContent: "center",
          flex: "1 1 100%",
          flexWrap: "wrap",
        }}
      >
        {props.subscriptionMode
          ? listState.cartProducts.length > 0 && (
              <ButtonOrange
                onClick={createSubscription}
                disabled={savingSubscription}
                label={
                  savingSubscription
                    ? "Creating subscription..."
                    : "Save New Subscription"
                }
              />
            )
          : mystate.farmDefaults.stripe_account_id &&
            mystate.farmDefaults.stripe_account_id.length > 3 &&
            !props.invoice && (
              <ButtonOrange
                onClick={() => checkForSavedPayment()}
                label={
                  Auth.getUserType() == "ADM"
                    ? "Admin Online Card Payment"
                    : "Pay By Card"
                }
              />
            )}
        {!props.subscriptionMode &&
          (Auth.getUserType() == "ADM" || Auth.getUserType() === "INS") &&
          !props.invoice && (
            <Link to={`${props.match.url}/manual`}>
              <ButtonOrange label={"Manual Payment"} />
            </Link>
          )}
        {!props.subscriptionMode &&
          Auth.getUserType() == "ADM" &&
          mystate.farmDefaults.can_use_invoices && (
            <Link to={`${props.match.url}/manualInvoice`}>
              <ButtonOrange label={"Create Invoice"} />
            </Link>
          )}
        {1 == 2 && <button onClick={() => offlinePayment()}>Offline</button>}
      </div>
      <div
        className="cancelButtonContainer"
        style={{
          display: "flex",
          justifyContent: "center",
          flex: "1 1 100%",
        }}
      >
        <ButtonBlue onClick={() => cancelCheckout()} label={"Cancel"} />
      </div>
    </div>
  );
};

export default OnlinePurchase;
